import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxGeneric,
  StyledList,
  StyledElements,
  StyledParagraph,
  StyledBoxDownCenter,
  StyledButton
} from './style';

import { Checkbox } from '../../../core/Checkbox';
import Modal from '../../../core/Modal';

const LinkedinImport = ({ title, text, label, dataLinkedin }) => (
  <Modal title={title}>
    <form action="#" method="get">
      <StyledBoxGeneric>
        <StyledParagraph>{text}</StyledParagraph>
        <StyledList>
          {dataLinkedin.map(item => (
            <StyledElements>{item.list}</StyledElements>
          ))}
        </StyledList>
        <Checkbox label={label} />
        <StyledBoxDownCenter>
          <StyledButton modal>Cancelar</StyledButton>
          <StyledButton secondary>Importar</StyledButton>
        </StyledBoxDownCenter>
      </StyledBoxGeneric>
    </form>
  </Modal>
);

LinkedinImport.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  label: PropTypes.string,
  dataLinkedin: PropTypes.arrayOf(
    PropTypes.shape({
      list: PropTypes.string
    })
  )
};

export default LinkedinImport;
